import { MULTIPLAYER_ARCHITECTURE } from '@/config/multiplayer';
import { useMultiplayerRoomConvex } from './useMultiplayerRoomConvex';
import { useMultiplayerRoomLan } from './useMultiplayerRoomLan';

export function useMultiplayerRoom() {
  if (MULTIPLAYER_ARCHITECTURE === 'lan-p2p') {
    return useMultiplayerRoomLan();
  }

  return useMultiplayerRoomConvex();
}
